import DriverDerailerTrait from './DriverDerailerTrait';
export default DriverDerailerTrait;
